export default __webpack_public_path__ + "static/media/Group9175.dab9cc3f.svg";